import { InjectionToken } from '@angular/core';

export type EventStatusCode =
  | 'scheduled'
  | 'confirmed'
  | 'completed'
  | 'cancelled'
  | 'hidden';

export interface EventStatusDef {
  eventStatusId: string;
  name: string;
  color?: string;
}

export const STATUS_DEF_MAP = new InjectionToken<
  Record<EventStatusCode, EventStatusDef>
>('STATUS_DEF_MAP');
